module.exports = __webpack_public_path__ + "static/media/ban.20068ee3.svg";